import { VideoItem } from 'services/data-manager/types';

import { StandardUavProps } from 'components/Ribbon/types';

export enum StreamTypes {
    live = 'live',
    startover = 'startover',
    catchup = 'catchup',
    vod = 'vod',
    npvr = 'npvr',
}

export type ShowPlayerConfig = {
    videoItem?: VideoItem;
    playbackType?: StreamTypes;
} & StandardUavProps;
